module.exports = __webpack_public_path__ + "static/media/search_button.30e9f14b.svg";